package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteSummary
import com.milta.feature.route.domain.repository.RouteRepository

/**
 * POST /api/v1/routes/{id}/reoptimize-in-place — re-orders the existing stops, no new stop added
 * (MIL-34). [latitude]/[longitude] (DOM-05) are the driver's current GPS position, forwarded as an
 * optional, more accurate depot; default to `null` (permission denied/location unavailable).
 */
class ReoptimizeInPlaceUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(id: String, latitude: Double? = null, longitude: Double? = null): RouteSummary =
        repository.reoptimizeInPlace(id, latitude, longitude)
}
